import styled from "styled-components";

interface ModalHeader {
  bgImagen?: string;
}

interface TabBody {
  minH?: any;
  maxH?: any;
}

export const ModalHeader = styled.div`
  background-image: url(${(p: ModalHeader) => (p.bgImagen ? p.bgImagen : "")});
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: local;
  background-size: cover;
  width: 100%;
  height: 5rem;
  padding: 1rem 2rem 1rem 2rem;
  display: flex;
  align-items: center;
  justify-items: center;
  font-family: MontserratRegular;
`;

export const ModalBody = styled.div`
  width: 100%;
  padding: 0.5rem 1.5rem 1.5rem 1.5rem;
  overflow-y: auto;
`;

export const ModalBodyContainer: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  min-height: ${(p: TabBody) => (p.minH ? p.minH : "480px")};
  max-height: ${(p: TabBody) => (p.maxH ? p.maxH : "480px")};
`;

export const TabPanel: any = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ModalFooter = styled.div`
  width: 100%;
  padding: 1rem 2rem 1rem 2rem;
  display: flex;
  flex-direction: row;
  justify-content: end;
`;
